import { state } from '../core/state.js';
import { $, $$, esc } from '../core/text.js';
import { advIntro } from '../game/screens.js';
import { renderAdventure } from '../game/ui.js';
import { renderStreak } from '../progress/streak.js';
import { renderBuddy } from '../progress/xp.js';
import { renderAchievements, renderShop } from '../shop/shop.js';
import { renderCommunity } from '../social/community.js';
import { renderFriends } from '../social/friends.js';
import { renderProfile } from '../social/profile.js';
import { renderCalendar } from '../views/calendar.js';
import { mountCollectionsInStats, renderCollections, renderDashboard } from '../views/dashboard.js';
import { renderDashboardV2 } from '../views/settings.js';
import { renderSecurity } from '../views/security.js';
import { renderCards, renderStats } from '../views/stats.js';
import { renderTree } from './sidebar.js';
import { SFX, toast } from './toast.js';

/* ══════════ Views ══════════ */
export const isV2 = () => document.body.classList.contains('design-v2');
export function setView(v) {
  state.view = v;
  $$('.view').forEach((el) => el.classList.add('hidden'));
  $(`#view-${v}`).classList.remove('hidden');
  if (v === 'dashboard' && isV2()) {                       // v2: eigenes Dashboard zeigen
    $('#view-dashboard').classList.add('hidden');
    $('#view-dashboard-v2').classList.remove('hidden');
  }
  $$('.nav-link').forEach((el) => el.classList.toggle('active', el.dataset.view === v));
  $$('.tab').forEach((el) => el.classList.toggle('active', el.dataset.view === v));
  $('#tabs').classList.toggle('hidden', ['study', 'settings', 'profile'].includes(v));
  refresh();
}
export function refresh() {
  renderTree(); renderStreak(); renderBuddy();
  if (state.view === 'dashboard') isV2() ? renderDashboardV2() : renderDashboard();
  if (state.view === 'cards') renderCards();
  if (state.view === 'collections') renderCollections();
  if (state.view === 'calendar') renderCalendar();
  if (state.view === 'stats') { renderStats(); mountCollectionsInStats(); renderCollections(); }
  if (state.view === 'achievements') renderAchievements();
  if (state.view === 'shop') renderShop();
  if (state.view === 'soon') renderSoon();
  if (state.view === 'community') renderCommunity();
  if (state.view === 'friends') renderFriends();
  if (state.view === 'profile') renderProfile();
  if (state.view === 'adventure') { renderAdventure(); advIntro(); }
  // Geräte, Anbieter und Protokoll kommen vom Server – deshalb erst beim
  // Öffnen der Einstellungen laden, nicht bei jedem refresh() nebenbei.
  if (state.view === 'settings') renderSecurity();
}

/* ══════════ Coming Soon ══════════ */
export const SOON_MODES = [
  { key: 'run',    icon: '🏃', title: 'Antwort-Run',  img: 'assets/soon_run.jpg',     desc: 'Beantworte Fragen in einem temporeichen Run und sammle Punkte, Münzen und Juwelen.' },
  { key: 'memory', icon: '🃏', title: 'Memory Match', img: 'assets/soon_memory.jpg',  desc: 'Finde passende Kartenpaare und trainiere dein Gedächtnis auf spielerische Weise.' },
  { key: 'boss',   icon: '⚔️', title: 'Boss Battle',   img: 'assets/soon_boss.jpg',    desc: 'Stelle dich mächtigen Wissensbossen und beweise dein Können in spannenden Duellen.' },
  { key: 'balloon',icon: '🎈', title: 'Ballon-Pop',    img: 'assets/soon_balloon.jpg', desc: 'Lass nur die richtige Antwort platzen, bevor die Ballons verschwinden.' },
  { key: 'bridge', icon: '🌉', title: 'Brückenbauer',  img: 'assets/soon_bridge.jpg',  desc: 'Baue mit richtigen Antworten eine stabile Brücke und erreiche das Ziel.' },
];
export const getNotify = () => { try { return JSON.parse(localStorage.getItem('cn-notify') || '[]'); } catch { return []; } };
/* Bild-Lightbox (Vorschaubilder vergrößert anzeigen) */
export function imgLightbox(src, title) {
  const ov = document.createElement('div');
  ov.className = 'img-lightbox';
  ov.innerHTML = `<figure class="lb-fig"><img src="${src}" alt="${esc(title || '')}">${title ? `<figcaption>${esc(title)}</figcaption>` : ''}</figure><button class="lb-close" aria-label="Schließen">✕</button>`;
  document.body.appendChild(ov);
  const close = () => ov.remove();
  ov.onclick = (e) => { if (e.target === ov || e.target.closest('.lb-close')) close(); };
  document.addEventListener('keydown', function esc2(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc2); } });
}
export function renderSoon() {
  const notified = getNotify();
  $('#soon-grid').innerHTML = SOON_MODES.map((m) => {
    const on = notified.includes(m.key);
    return `<div class="soon-card">
      <div class="soon-cover" data-zoom="${m.img}" data-title="${esc(m.title)}" title="Klicken zum Vergrößern"><img src="${m.img}" alt="Vorschau ${esc(m.title)}" loading="lazy"><span class="soon-zoom">🔍</span></div>
      <div class="soon-card-body">
        <div class="soon-card-head"><span class="soon-card-ico">${m.icon}</span><span class="soon-badge">Bald verfügbar</span></div>
        <h4 class="soon-card-title">${esc(m.title)}</h4>
        <p class="soon-card-desc">${esc(m.desc)}</p>
        <button class="soon-notify ${on ? 'on' : ''}" data-notify="${m.key}">${on ? '✓ Benachrichtigung aktiviert' : '🔔 Benachrichtige mich'}</button>
      </div>
    </div>`;
  }).join('');
  $$('#soon-grid [data-zoom]').forEach((c) => { c.onclick = () => imgLightbox(c.dataset.zoom, c.dataset.title); });
  $$('[data-notify]').forEach((btn) => {
    btn.onclick = () => {
      const key = btn.dataset.notify;
      let list = getNotify();
      const on = list.includes(key);
      list = on ? list.filter((k) => k !== key) : [...list, key];
      localStorage.setItem('cn-notify', JSON.stringify(list));
      btn.classList.toggle('on', !on);
      btn.textContent = on ? '🔔 Benachrichtige mich' : '✓ Benachrichtigung aktiviert';
      if (!on) { toast('Wir sagen dir Bescheid ✦'); SFX.good(); }
    };
  });
  const fb = $('#soon-feedback');
  if (fb) fb.onclick = () => toast('Danke fürs Interesse! Das Feedback-Formular kommt bald 🌱');
}

